import { Link } from '@tanstack/react-router'
import * as z from 'zod'

import { IconDiscord, IconTelegram, IconWhatsApp } from '@gto/ui/assets'
import { EnvelopeIcon } from '@gto/ui/icons/solid'

import { useSiteSettings } from '@/hooks/use-site-settings'

export const gaTagSchema = z.enum(['discord', 'whatsapp', 'telegram', 'email'])

export type GaTag = z.infer<typeof gaTagSchema>

export const useSupportLinks = () => {
  const { settings } = useSiteSettings()

  if (!settings) {
    return []
  }

  const links = []

  if (typeof settings.discord_url === 'string' && settings.discord_url.length > 0) {
    links.push({
      label: 'Discord',
      href: settings.discord_url,
      component: Link,
      target: '_blank',
      rel: 'noopener noreferrer',
      'aria-label': 'Discord RakeBack Wizard',
      gaTag: 'discord' as GaTag,
      icon: (
        <IconDiscord
          color="#fff"
          height={24}
          width={24}
        />
      ),
    })
  }

  if (typeof settings.whatsapp_url === 'string' && settings.whatsapp_url.length > 0) {
    links.push({
      label: 'WhatsApp',
      href: settings.whatsapp_url,
      component: Link,
      target: '_blank',
      rel: 'noopener noreferrer',
      'aria-label': 'WhatsApp RakeBack Wizard',
      gaTag: 'whatsapp' as GaTag,
      icon: (
        <IconWhatsApp
          color="#fff"
          height={24}
          width={24}
        />
      ),
    })
  }

  if (typeof settings.telegram_url === 'string' && settings.telegram_url.length > 0) {
    links.push({
      label: 'Telegram',
      href: settings.telegram_url,
      component: Link,
      target: '_blank',
      rel: 'noopener noreferrer',
      'aria-label': 'Telegram RakeBack Wizard',
      gaTag: 'telegram' as GaTag,
      icon: (
        <IconTelegram
          color="#fff"
          height={24}
          width={24}
        />
      ),
    })
  }

  if (typeof settings.contact_email === 'string' && settings.contact_email.length > 0) {
    links.push({
      label: 'Email',
      href: `mailto:${settings.contact_email}`,
      component: Link,
      target: '_blank',
      rel: 'noopener noreferrer',
      'aria-label': 'Email RakeBack Wizard',
      gaTag: 'email' as GaTag,
      icon: (
        <EnvelopeIcon
          color="#fff"
          height={22}
          style={{ marginRight: 2 }}
          width={22}
        />
      ),
    })
  }

  return links
}
